import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiGrid, FiShoppingCart, FiShield, FiPlusSquare } from 'react-icons/fi';
import './MobileNav.css';

const MobileNav = () => {
    const [cartCount, setCartCount] = useState(0);

    useEffect(() => {
        const updateCartCount = () => {
            const cart = JSON.parse(localStorage.getItem('cart') || '[]');
            const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
            setCartCount(totalItems);
        };

        updateCartCount();
        window.addEventListener('storage', updateCartCount);
        window.addEventListener('cartUpdated', updateCartCount);

        return () => {
            window.removeEventListener('storage', updateCartCount);
            window.removeEventListener('cartUpdated', updateCartCount);
        };
    }, []);

    return (
        <nav className="mobile-nav">
            <NavLink to="/" className={({ isActive }) => isActive ? "mobile-nav-item active" : "mobile-nav-item"}>
                <FiHome />
                <span>Home</span>
            </NavLink>
            <NavLink to="/shop" className={({ isActive }) => isActive ? "mobile-nav-item active" : "mobile-nav-item"}>
                <FiGrid />
                <span>Shop</span>
            </NavLink>
            <NavLink to="/customize" className={({ isActive }) => isActive ? "mobile-nav-item active" : "mobile-nav-item"}>
                <FiPlusSquare />
                <span>Customize</span>
            </NavLink>
            <NavLink to="/cart" className={({ isActive }) => isActive ? "mobile-nav-item active" : "mobile-nav-item"}>
                <div className="mobile-cart-icon">
                    <FiShoppingCart />
                    {cartCount > 0 && <span className="mobile-cart-badge">{cartCount}</span>}
                </div>
                <span>Cart</span>
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => isActive ? "mobile-nav-item active" : "mobile-nav-item"}>
                <FiShield />
                <span>Privacy</span>
            </NavLink>
        </nav>
    );
};

export default MobileNav;
